import { CoordinatesPutRequest } from './CoordinatesPutRequest';
import {
  CoordinatesPutInterface,
  CoordinatesInterface,
  GeoLocationServiceInterface,
  RequestOptionsInterface,
} from './types';

document.addEventListener('DOMContentLoaded', function () {
  const geoApi = new GeoLocationService();
  geoApi.attachGeolocationRequests(document.querySelectorAll('[data-request-geolocation]'));
});

export class GeoLocationService implements GeoLocationServiceInterface {
  private readonly isApiAvailable: boolean = false;
  private readonly requestOptions: RequestOptionsInterface = {
    maximumAge: 5 * 60 * 1000,
    timeout: 20000,
  };
  private coordinates: CoordinatesInterface = { latitude: 0.0, longitude: 0.0 };
  private storer: CoordinatesPutInterface;

  public constructor() {
    this.isApiAvailable = 'geolocation' in navigator;
    this.storer = new CoordinatesPutRequest();
  }

  public requestLocation(onSuccess: () => void, onError?: () => void): void {
    const self = this;
    if (this.isAvailable()) {
      navigator.geolocation.getCurrentPosition(
        function (position: any) {
          self.coordinates = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          self.storer.put(self.coordinates);
          onSuccess();
        },
        function (positionError: any) {
          console.warn(positionError);
          onError && onError();
        },
        this.requestOptions
      );
    }
  }

  public attachGeolocationRequests(elements: NodeList) {
    let self = this;
    elements.forEach(function (element) {
      switch (element.nodeName) {
        case 'A':
          element.addEventListener('click', function (this: typeof element, event) {
            event.preventDefault();
            let href = (this as HTMLElement).getAttribute('href') as string;
            self.requestLocation(
              function () {
                self.redirect(href);
              },
              function () {
                self.redirect(href);
              }
            );
          });
          break;
        case 'BODY':
          self.requestLocation(function () {
            let params = new URLSearchParams(location.search.slice(1));
            params.delete('locateUser');
            location.assign(location.pathname + (params.toString().length > 0 ? '?' : '') + params);
          });
          break;
        case 'BUTTON':
          element.addEventListener('click', function (event: Event) {
            let form: HTMLFormElement = (event.target as HTMLFormElement).form;
            event.preventDefault();
            self.requestLocation(form.submit.bind(form));
          });
          break;
        case 'FORM':
          element.addEventListener('submit', function (event: Event) {
            event.preventDefault();
            self.requestLocation((event.target as HTMLFormElement).submit.bind(self));
          });
          break;
        default:
          console.debug('unsupported geo location trigger node type ' + element.nodeName);
      }
    });
  }

  redirect(href: string): void {
    location.assign(href);
  }

  isAvailable(): boolean {
    return this.isApiAvailable;
  }
}
